import { render, staticRenderFns } from "./FormGroupTwo.vue?vue&type=template&id=5fc58407&scoped=true&"
import script from "./FormGroupTwo.vue?vue&type=script&lang=js&"
export * from "./FormGroupTwo.vue?vue&type=script&lang=js&"
import style0 from "./FormGroupTwo.vue?vue&type=style&index=0&id=5fc58407&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc58407",
  null
  
)

export default component.exports